/**
 * Photo URL helpers.
 * Prefers SEO-friendly slug URL (/api/img/{seo_slug}) when available,
 * falls back to legacy storage_path URL.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Build the public URL for a gallery photo.
 * @param {object} photo — gallery_photos document with { storage_path, seo_slug }
 * @returns {string} URL to use as <img src>
 */
export function photoUrl(photo) {
  if (!photo) return "";
  if (photo.seo_slug) {
    return `${BACKEND_URL}/api/img/${photo.seo_slug}`;
  }
  if (photo.storage_path) {
    return `${BACKEND_URL}/api/files/${photo.storage_path}`;
  }
  return "";
}

/**
 * Descriptive alt text for a photo — uses seo_alt when available.
 * @param {object} photo
 * @param {string} fallback — used if seo_alt missing
 */
export function photoAlt(photo, fallback = "") {
  return photo?.seo_alt || fallback;
}
